import useStore from "./slice";

export const useFetchData =
  () => useStore(
    (state) => state.fetchData
  )
